import cloneDeep from 'lodash/fp/cloneDeep'
import { events } from './adviserProfileWorkExperienceEditorActions'
import { events as containerEvents } from '../AdviserProfileEditorContainer/adviserProfileEditorContainerActions'
import { validiateTextField } from '../../../common/forms/validationFunctions'

const initialState = {
  loadingWorkExperience: false,
  editingWorkExperience: false,
  editingWorkExperienceIndex: -1,
  deletingWorkExperienceModal: false,
  deletingWorkExperienceIndex: -1,
  workExperiencesBeforeEditing: [],
  positionStartYear: null,
  positionStartMonth: null,
  positionEndYear: null,
  positionEndMonth: null,
  isInvalid: {
    formIsValid: true,
    position: {
      valid: true,
      isInvalid: false,
      message: null
    },
    company: {
      valid: true,
      isInvalid: false,
      message: null
    },
    startYear: {
      valid: true,
      isInvalid: false,
      message: null
    },
    startMonth: {
      valid: true,
      isInvalid: false,
      message: null
    },
    endYear: {
      valid: true,
      isInvalid: false,
      message: null
    },
    endMonth: {
      valid: true,
      isInvalid: false,
      message: null
    }
  }
}

const isFormValid = (state) => {
  const validationstate = state.experiences.isInvalid
  let value = (validationstate.position.valid &&
    validationstate.company.valid &&
    validationstate.startYear.valid &&
    validationstate.endYear.valid &&
    validationstate.startMonth.valid &&
    validationstate.endMonth.valid)
  return value
}

export default (state = initialState, action) => {
  var newState = copyWorkExperienceState(state)
  const { add, edit, set, deletes } = events
  let date

  switch (action.type) {
    case containerEvents.edit.cancel:
      newState.experiences = cloneDeep(initialState)
      return newState
    case add.experience:
      newState.experiences.editingWorkExperience = true
      newState.experiences.editingWorkExperienceIndex = newState.profile.workExperiences.length
      newState.experiences.workExperiencesBeforeEditing = cloneDeep(newState.profile.workExperiences)
      newState.profile.workExperiences.push(action.experience)
      newState.experiences.isInvalid.position.valid = false
      newState.experiences.isInvalid.company.valid = false
      newState.experiences.isInvalid.startMonth.valid = true
      newState.experiences.isInvalid.endMonth.valid = true
      newState.experiences.isInvalid.startYear.valid = true
      newState.experiences.isInvalid.endYear.valid = true
      date = new Date(Date.now())
      newState.experiences.positionStartMonth = 0
      newState.experiences.positionStartYear = date.getFullYear() - 1
      newState.experiences.positionEndYear = date.getFullYear()
      newState.experiences.positionEndMonth = 11
      newState.profile.workExperiences[newState.experiences.editingWorkExperienceIndex].positionStartDate = date.toISOString()
      newState.experiences.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case edit.start:
      newState.experiences.editingWorkExperience = true
      newState.experiences.editingWorkExperienceIndex = action.index
      date = new Date(newState.profile.workExperiences[newState.experiences.editingWorkExperienceIndex].positionStartDate)
      newState.experiences.positionStartMonth = date.getMonth()
      newState.experiences.positionStartYear = date.getFullYear()
      if (newState.profile.workExperiences[newState.experiences.editingWorkExperienceIndex].positionEndDate !== null) {
        date = new Date(newState.profile.workExperiences[newState.experiences.editingWorkExperienceIndex].positionEndDate)
        newState.experiences.positionEndMonth = date.getMonth()
        newState.experiences.positionEndYear = date.getFullYear()
      }
      newState.experiences.workExperiencesBeforeEditing = cloneDeep(newState.profile.workExperiences)
      return newState
    case edit.stop:
      newState.experiences.editingWorkExperience = false
      newState.experiences.editingWorkExperienceIndex = initialState.editingWorkExperienceIndex
      newState.experiences.positionStartMonth = initialState.positionStartMonth
      newState.experiences.positionStartYear = initialState.positionStartYear
      newState.experiences.positionEndMonth = initialState.positionEndMonth
      newState.experiences.positionEndYear = initialState.positionEndYear
      newState.experiences.isInvalid = cloneDeep(initialState.isInvalid)
      newState.experiences.isInvalid.position = cloneDeep(initialState.isInvalid.position)
      newState.experiences.isInvalid.company = cloneDeep(initialState.isInvalid.company)
      newState.experiences.isInvalid.startYear = cloneDeep(initialState.isInvalid.startYear)
      newState.experiences.isInvalid.endYear = cloneDeep(initialState.isInvalid.endYear)
      newState.experiences.workExperiencesBeforeEditing = []
      newState.edited = true
      return newState
    case edit.cancel:
      newState.experiences.editingWorkExperience = false
      newState.experiences.editingWorkExperienceIndex = initialState.editingWorkExperienceIndex
      newState.experiences.positionStartMonth = initialState.positionStartMonth
      newState.experiences.positionStartYear = initialState.positionStartYear
      newState.experiences.positionEndMonth = initialState.positionEndMonth
      newState.experiences.positionEndYear = initialState.positionEndYear
      newState.experiences.isInvalid = cloneDeep(initialState.isInvalid)
      newState.experiences.isInvalid.position = cloneDeep(initialState.isInvalid.position)
      newState.experiences.isInvalid.company = cloneDeep(initialState.isInvalid.company)
      newState.experiences.isInvalid.startYear = cloneDeep(initialState.isInvalid.startYear)
      newState.experiences.isInvalid.endYear = cloneDeep(initialState.isInvalid.endYear)
      newState.profile.workExperiences = cloneDeep(newState.experiences.workExperiencesBeforeEditing)
      newState.experiences.workExperiencesBeforeEditing = []
      return newState
    case set.experience:
      newState.profile.workExperiences[newState.experiences.editingWorkExperienceIndex] = cloneDeep(action.experience)
      newState.experiences.isInvalid.position = validiateTextField(action.experience.position, 255, true)
      newState.experiences.isInvalid.position = validiateTextField(action.experience.company, 255, true)
      date = new Date(newState.profile.workExperiences[newState.experiences.editingWorkExperienceIndex].positionStartDate)
      date.setMonth(newState.experiences.positionStartMonth)
      date.setFullYear(newState.experiences.positionStartYear)
      newState.profile.workExperiences[newState.experiences.editingWorkExperienceIndex].positionStartDate = date.toISOString()
      if (!newState.profile.workExperiences[newState.experiences.editingWorkExperienceIndex].isCurrentJob) {
        date = new Date(newState.profile.workExperiences[newState.experiences.editingWorkExperienceIndex].positionEndDate)
        date.setMonth(newState.experiences.positionEndMonth)
        date.setFullYear(newState.experiences.positionEndYear)
        newState.profile.workExperiences[newState.experiences.editingWorkExperienceIndex].positionEndDate = date.toISOString()
      }
      newState.experiences.isInvalid.position = action.validationResult.position
      newState.experiences.isInvalid.company = action.validationResult.company
      newState.experiences.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case set.startMonth:
      newState.experiences.positionStartMonth = action.month
      newState.experiences.isInvalid.startMonth = cloneDeep(action.validationResult)
      newState.experiences.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case set.startYear:
      newState.experiences.positionStartYear = parseInt(action.year)
      newState.experiences.isInvalid.startYear = cloneDeep(action.validationResult)
      newState.experiences.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case set.endMonth:
      newState.experiences.positionEndMonth = action.month
      newState.experiences.isInvalid.endMonth = cloneDeep(action.validationResult)
      newState.experiences.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case set.endYear:
      newState.experiences.positionEndYear = parseInt(action.year)
      newState.experiences.isInvalid.endYear = cloneDeep(action.validationResult)
      newState.experiences.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case set.endDateCurrent:
      if (!newState.profile.workExperiences[newState.experiences.editingWorkExperienceIndex].isCurrentJob) {
        newState.profile.workExperiences[newState.experiences.editingWorkExperienceIndex].positionEndDate = null
        newState.profile.workExperiences[newState.experiences.editingWorkExperienceIndex].isCurrentJob = true
        newState.experiences.positionEndMonth = null
        newState.experiences.positionEndYear = null
        newState.experiences.isInvalid.endYear.valid = true
        newState.experiences.isInvalid.endMonth.valid = true
      } else {
        date = new Date(Date.now())
        newState.profile.workExperiences[newState.experiences.editingWorkExperienceIndex].positionEndDate = date.toISOString()
        newState.profile.workExperiences[newState.experiences.editingWorkExperienceIndex].isCurrentJob = false
        newState.experiences.positionEndMonth = date.getMonth()
        newState.experiences.positionEndYear = date.getFullYear()
        newState.experiences.isInvalid.endYear.valid = true
      }
      // Recompute so toggling "Current Job" (which clears the end-year error) re-enables Save.
      newState.experiences.isInvalid.formIsValid = isFormValid(newState)
      return newState
    case deletes.experience:
      newState.profile.workExperiences = newState.profile.workExperiences.filter((experience, index) => index !== newState.experiences.deletingWorkExperienceIndex)
      newState.experiences.deletingWorkExperienceIndex = initialState.deletingWorkExperienceIndex
      newState.experiences.deletingWorkExperienceModal = false
      newState.edited = true

      return newState
    case deletes.modal:
      newState.experiences.deletingWorkExperienceIndex = action.index
      newState.experiences.deletingWorkExperienceModal = true
      return newState
    case deletes.cancel:
      newState.experiences.deletingWorkExperienceIndex = initialState.deletingWorkExperienceIndex
      newState.experiences.deletingWorkExperienceModal = false
      return newState
  }

  return state
}

const copyWorkExperienceState = (state) => {
  var newState = cloneDeep(state)
  newState.profile = cloneDeep(state.profile)
  if (state.profile) {
    newState.profile.workExperiences = cloneDeep(state.profile.workExperiences)
  }
  return newState
}
